import { createSelector } from 'selectors'
import { constant } from './constant'

const { selector } = constant

export const getGridStackTargetSelector = () => createSelector<HTMLElement>({ selector: selector.target })

export const getSubGridStackTargetSelectors = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: selector.subTarget }, true)

export const getNestedGridStackSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement | null>({ scope, selector: selector.nestedTarget })

export const getGridItemSelectors = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: selector.item }, true)

export const getGridStackNewBlockSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: selector.newBlock })

export const getItemHeadSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: selector.headerItem })

export const getItemFooterSelector = (scope: HTMLElement) =>
	createSelector<HTMLElement>({ scope, selector: selector.footerItem })

export const getGridStackFloatHandler = () => createSelector<HTMLElement>({ selector: selector.floatHandler })
